module.exports = __webpack_public_path__ + "static/media/all_icon_white.0d94f361.svg";